import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { Agendamiento } from "../interfaces"
import { cellLineaRazonSocial, cellNotFilter } from "../utils"
import { EstadoComponente } from "../components/ui"
import { EstadosAgendamientoEnumChoice, EstadosContratoChoiceEnum } from "../constants"
import { fnTipoContrato } from "./useTableColumnsPreventa"
import { tipoContrato } from "@/erp/operaciones/agendamiento/shared/hooks"
import InfoUser from "../components/ui/InfoUser/InfoUser"

type EstadoResult = { color: string; texto: string };

// Mapa de combinaciones exactas

const handleEstadoAgendaminto = (estado: string): EstadoResult => {

  switch (estado) {
    case EstadosAgendamientoEnumChoice.FINALIZADO:
      return {
        color: 'green',
        texto: estado
      }

    case EstadosAgendamientoEnumChoice.RECORDINADO:
      return {
        color: 'purple',
        texto: estado
      }

    case EstadosAgendamientoEnumChoice.CANCELADO:
      return {
        color: 'red',
        texto: estado
      }

    case EstadosAgendamientoEnumChoice.PRERECHAZADO:
      return {
        color: 'orange',
        texto: EstadosAgendamientoEnumChoice.GESTION_VENTA
      }

    default:
      return {
        color: 'blue',
        texto: 'N/A'
      }
  }

}

const handleEstadoInstalacion = (estado: string): EstadoResult => {

  switch (estado) {
    case EstadosContratoChoiceEnum.ACTIVO:
      return {
        color: 'green',
        texto: EstadosContratoChoiceEnum.FINALIZADO
      }

    case EstadosContratoChoiceEnum.SUSPENDIDO:
      return {
        color: 'blue',
        texto: EstadosContratoChoiceEnum.EN_ESPERA
      }

    default:
      return {
        color: 'blue',
        texto: estado
      }
  }
}
export const useTableColumnsInformeInstalacion = () => {

  const columnsInforme = useMemo<MRT_ColumnDef<Agendamiento>[]>(() => [
    {
      accessorKey: "cliente_razon_social",
      header: "Cliente",
      size: 300,
      Cell: ({ row }) =>
        cellLineaRazonSocial(
          row.original.contrato_data,
          row.original.prospecto_data?.razon_social!
        ),
    },
    {
      accessorKey: "identificacion",
      header: "Identificación",
      Cell: ({ row }) =>
        row.original?.prospecto_data?.identificacion || "N/A",
    },
    {
      ...cellNotFilter,
      accessorKey: "estado_agendamiento",
      header: "Estado Agendamiento",
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        const resp = handleEstadoAgendaminto(row.original.estado_agendamiento!);
        return (
          <EstadoComponente
            backgroundColor={resp.color}
            texto={resp.texto}
          />
        )
      }
    },
    {
      ...cellNotFilter,
      accessorKey: "estado_instalacion",
      header: "Estado Instalación",
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        const resp = handleEstadoInstalacion(row.original.contrato_data
          ? row.original.contrato_data.estado_contrato : 'N/A');
        return (
          <EstadoComponente
            backgroundColor={resp.color}
            texto={resp.texto}
          />
        )
      }
    },
    {
      ...cellNotFilter,
      accessorKey: "fecha_instalacion",
      header: "Fecha instalación",
      size: 180,
    },
    {
      ...cellNotFilter,
      accessorKey: "hora_instalacion",
      header: "Hora instalación",
      size: 180,
    },

    {
      accessorKey: "requiere_contrato_fisico",
      header: "Tipo de Contrato",
      size: 250,
      filterVariant: 'select',
      filterSelectOptions: tipoContrato,
      muiTableHeadCellFilterTextFieldProps: {
        select: true,
      },
      Cell: ({ row }) => (
        <EstadoComponente
          backgroundColor={
            fnTipoContrato(
              row.original.preventa_data!.pre_requiere_contrato_fisico,
              row.original.preventa_data!.requiere_contrato_fisico
            ).color
          }
          texto={
            fnTipoContrato(
              row.original.preventa_data!.pre_requiere_contrato_fisico,
              row.original.preventa_data!.requiere_contrato_fisico
            ).texto
          }
        />
      ),
    },
    {
      accessorKey: "contrato_plan",
      header: "Plan de internet",
      size: 210,
      Cell: ({ row }) => {
        return row.original?.plan_data?.nombre || "N/A";
      },
    },

    {
      accessorKey: "flota_nombre",
      header: "flota",
      Cell: ({ row }) => row.original?.flota_data?.nombre || "N/A",
    },
    {
      accessorKey: "ciudad_nombre",
      header: "Ciudad",
      size: 150,
      Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
    },
    {
      ...cellNotFilter,
      accessorKey: "motivo_rechazo",
      header: "Motivo Rechazo",
      size: 150,
      Cell: ({ row }) => row.original.motivo_rechazo_data
        ? row.original.motivo_rechazo_data.nombre
        : "N/A"
    },
    {
      accessorKey: 'asesor',
      header: 'Asesor',
      size: 180,
      Cell: ({ row }) =>
        <InfoUser
          user={row.original.user_create ?? 'N/A'}
        />
    }
  ], [])

  return {
    columnsInforme
  }
}